import { render, staticRenderFns } from "./sidelistIntegral.vue?vue&type=template&id=a6654eb8&scoped=true"
import script from "./sidelistIntegral.vue?vue&type=script&lang=js"
export * from "./sidelistIntegral.vue?vue&type=script&lang=js"
import style0 from "./sidelistIntegral.vue?vue&type=style&index=0&id=a6654eb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6654eb8",
  null
  
)

export default component.exports